export const generateClassList = (baseClass, conditionalClasses, styles) => {
    const classes = [
      baseClass,
      ...Object.entries(conditionalClasses).map(([key, isActive]) =>
        isActive ? styles[key] : ""
      ),
    ];
    return classes.filter(Boolean).join(" ");
  };